import { useRecoilValue } from "recoil";

import { useBulkEditFormContext } from "@ryde/redux";
import { bulkSelectedControlsAtomFamily } from "@ryde/shared";

export const useIsBulkControlSelected = (controlName: string): boolean => {
  const { entity } = useBulkEditFormContext();
  const selectedFields = useRecoilValue(bulkSelectedControlsAtomFamily(entity));

  return selectedFields.includes(controlName);
};
